/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightSelectedObservation } from "./FlightSelectedObservation";
import {
  FlightSelectedObservationFromJSON,
  FlightSelectedObservationFromJSONTyped,
  FlightSelectedObservationToJSON,
  FlightSelectedObservationToJSONTyped,
} from "./FlightSelectedObservation";

/**
 *
 * @export
 * @interface FlightBookingHandoffCreateRequest
 */
export interface FlightBookingHandoffCreateRequest {
  /**
   * Signed native test offer from the authenticated test search; required when test=true.
   * @type {string}
   * @memberof FlightBookingHandoffCreateRequest
   */
  selectionToken?: string;
  /**
   *
   * @type {FlightSelectedObservation}
   * @memberof FlightBookingHandoffCreateRequest
   */
  selectedObservation?: FlightSelectedObservation;
}

/**
 * Check if a given object implements the FlightBookingHandoffCreateRequest interface.
 */
export function instanceOfFlightBookingHandoffCreateRequest(
  value: object
): value is FlightBookingHandoffCreateRequest {
  return true;
}

export function FlightBookingHandoffCreateRequestFromJSON(
  json: any
): FlightBookingHandoffCreateRequest {
  return FlightBookingHandoffCreateRequestFromJSONTyped(json, false);
}

export function FlightBookingHandoffCreateRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBookingHandoffCreateRequest {
  if (json == null) {
    return json;
  }
  return {
    selectionToken:
      json["selection_token"] == null ? undefined : json["selection_token"],
    selectedObservation:
      json["selected_observation"] == null
        ? undefined
        : FlightSelectedObservationFromJSON(json["selected_observation"]),
  };
}

export function FlightBookingHandoffCreateRequestToJSON(
  json: any
): FlightBookingHandoffCreateRequest {
  return FlightBookingHandoffCreateRequestToJSONTyped(json, false);
}

export function FlightBookingHandoffCreateRequestToJSONTyped(
  value?: FlightBookingHandoffCreateRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    selection_token: value["selectionToken"],
    selected_observation: FlightSelectedObservationToJSON(
      value["selectedObservation"]
    ),
  };
}
